// src/pages/RegisterPage.tsx — Site officiel Vanessa
import { RegisterForm } from '@/features/auth/components/RegisterForm';

export default function RegisterPage() {
    return (
        <div className="flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-md rounded-3xl border border-gray-200 bg-white p-6 shadow-md sm:p-8">
                <div className="mb-8 text-center">
                    <img src="/vanessa-avatar.png" alt="" className="mx-auto mb-4 h-20 w-20 rounded-full object-cover ring-4 ring-brand" />
                    <h1 className="text-3xl font-bold text-ink">Créer un compte</h1>
                    <p className="mt-1 text-base text-gray-600">
                        Le même compte sert pour le site, l’API et l’application Vanessa.
                    </p>
                </div>
                <RegisterForm />
            </div>
        </div>
    );
}
